// extracted by mini-css-extract-plugin
export var backgroundShape = "BackgroundShape-module--backgroundShape--788f2";
export var companyValues = "BackgroundShape-module--companyValues--a7601";
export var funnelBackgroundShape = "BackgroundShape-module--funnelBackgroundShape--a0320";